"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NUM_OF_PRODUCTS = exports.MAX_NAME_LENGTH = exports.DATA_TEST_ID = void 0;
/* istanbul ignore file */ const NUM_OF_PRODUCTS = exports.NUM_OF_PRODUCTS = 12;
const MAX_NAME_LENGTH = exports.MAX_NAME_LENGTH = 100;
const DATA_TEST_ID = exports.DATA_TEST_ID = 'data-testid';
